// Adds scroll animation to scroll to top
jQuery(document).ready(function () {
    jQuery(".footer-scroll-to-top").hide();
    jQuery(window).scroll(function() {
        if (jQuery(this).scrollTop() > 700) {
            jQuery('.footer-scroll-to-top').fadeIn('slow');
        }
        else {
            jQuery('.footer-scroll-to-top').fadeOut('slow');
        }
    });
    jQuery(".footer-scroll-to-top").on('click', function () {
        jQuery("html, body").animate({scrollTop: 0}, 400);
    });
});